
import { AuthProvider } from "../contexts/AuthContext";
import AppRouter from "../components/AppRouter";

const Index = () => {
  return (
    <AuthProvider>
      <AppRouter />
    </AuthProvider>
  );
};

export default Index;
